module.exports = __webpack_public_path__ + "media/images/gallery/dark_nebulae/B_33/horsehead_nebula-7637757e8a0e0335f55e20371f92f6b8.jpg";